import Link from "next/link";
import React, { PropsWithChildren } from "react";

import styles from "./GlowyCallToAction.module.css";

type PropTypes = {
  href: string;
};

const GlowyCallToAction: React.FC<PropsWithChildren<PropTypes>> = ({ href, children }) => {
  return (
    <Link href={href}>
      <a className={styles.callToAction}>{children}</a>
    </Link>
  );
};

export default GlowyCallToAction;
